import { Component, Input, OnInit } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { ChartType, ColumnChartName } from '@ddt-web/chart';
import { ColorsConfig } from '@ddt-web/config';
import { InjectConfig, SharedConfigKey } from '@ddt-web/config-layer';
import { ComponentData } from '@ddt-web/data-service';
import { EsgTranslationUtil } from '@ddt-web/generic-utils';

@Component({
	selector: 'mb-esg-uplift',
	templateUrl: './esg-uplift.component.html',
	styleUrls: ['./esg-uplift.component.scss']
})
export class EsgUpliftComponent implements OnInit {

	@InjectConfig(SharedConfigKey.EsgRatingsRangeScale) private readonly esgRatingScale = {};

	@Input() public data: ComponentData;
	public chartType: ChartType = ChartType.Column;
	public chartName: ColumnChartName = ColumnChartName.EsgUplift;
	public customChartAttributes: any;
	public modelNameList: string[] = [];
	public modelLegendColors: string[] = [];
	public modelBenchmarkLegendColors: string[] = [];

	constructor(
		public contentService: ContentService
	) { }

	public ngOnInit(): void {
		if (this.data.success) {
			this.modelNameList = this.defineModelList();
			this.defineLegendColors();
			const esgRatingsScaleMap = { ...this.esgRatingScale };
			this.customChartAttributes = {
				plotOptions: {
					series: {
						animation: false
					},
					column: {
						colorByPoint: true
					}
				},
				yAxis: {
					title: {
						enabled: true,
						text: this.contentService.get('ESG_UPLIFT_Y_AXIS_LABEL', 'ESG Score')
					},
					endOnTick: false
				},
				hasDataLabels: true,
				esgRatingsScaleMap: this.esgRatingScale,
				chart: { height: 400 },
				categories: this.modelNameList,
				useHTML: true,
				tooltip: {
					formatter: function (): string {
						const translatedLabel: string = EsgTranslationUtil.getEsgLetterRating(esgRatingsScaleMap, this.y);
						return `<div class="text-bold">${this.key}</div>` +
							`<div class="tooltip row text-12"><span class="col-16">${this.series.name}</span>` +
							`<span class="col-8 text-align-right">${translatedLabel}</span></div>`;
					}
				}
			};
		}
	}

	private defineModelList(): string[] {
		const cells = this.data?.tabs?.[1]?.tableData?.[0]?.cells ?? [];
		return cells.map(item => {
			return item[0].formattedValue;
		});
	}

	private defineLegendColors(): void {
		this.modelLegendColors = this.fillColors(ColorsConfig.ESG_UPLIFT_COLORS, 0, (Math.min(this.modelNameList.length, 6)));
		this.modelBenchmarkLegendColors = this.fillColors(ColorsConfig.ESG_UPLIFT_BENCHMARK_COLORS, 0, (Math.min(this.modelNameList.length, 6)));
		if (this.modelNameList.length > 6) { //we will have max 11 models
			this.modelLegendColors.push(...this.fillColors(ColorsConfig.ESG_UPLIFT_COLORS, 6, this.modelNameList.length));
			this.modelBenchmarkLegendColors.push(...this.fillColors(ColorsConfig.ESG_UPLIFT_BENCHMARK_COLORS, 6, this.modelNameList.length));

		}
	}

	private fillColors(colorList: string[], startIndex: number, endIndex: number): string[] {
		const targetArray = [];
		let colorIndex = 0;
		for (let i = startIndex; i < endIndex; i++) {
			targetArray[colorIndex] = colorList[colorIndex];
			colorIndex++;
		}
		return targetArray;
	}
}
